import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const SpamRules = () => {
  const Reset = () => {
    window.location.reload();
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const [operations1, setOperations1] = useState("");
  const [open, setOpen] = useState();

  const [ValuesFormik, setValuesFormik] = useState();
  const [data, setData] = useState([]);
  const [response, setResponse] = useState("");

  console.log("operations1------", operations1);
  const [value01, setValue01] = useState(null);
  // console.log("condition2-----", condition2);

  // .....................................Formik............................................//

  const initialValues = {
    values: "",
    values1: "",
    values2: "",
    values3: "",
    values4: "",
    ruleName: "",
    description: "",
  };

  // const validationSchema = yup.object({
  //   values: yup
  //     .string()
  //     .min(3, "Please enter atleast 3 characters in values")
  //     .required("Required"),
  // });
  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `http://192.168.167.66:5050/admin/v1/medium/create`,
          {
            name: values.Name,
            userId: Number(localStorage.getItem("UserId")),
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          GetMedium();
          toast.success(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        toast.error("Something went wrong", {
          theme: "colored",
        });
      }
    },
  });

  const userid = Number(localStorage.getItem("UserId"));
  // console.log("ppp", userid);
  const handleChange11 = (e) => {
    setResponse(e.target.value);
  };
  const [attribute2, setAttribute2] = useState("");
  console.log("attribute2-----", attribute2);

  const [attribute3, setAttribute3] = useState("");
  console.log("attribute3-----", attribute3);
  const handleChange16 = (e) => {
    setAttribute3(e.target.value);
  };
  async function GetMedium() {
    try {
      const result = await common_axios.get(
        `http://192.168.167.66:5050/admin/v1/medium/list`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.mediumList);
      } else {
        setOpen(false);
        toast.error(result.data.statusDescription.statusMessage);
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);

      toast.error("Please check your network");
    }
  }

  useEffect(() => {
    GetMedium();
  }, []);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const modelButtonApprove = useRef(null);

  const columns = useMemo(
    () => [
      {
        Header: "userId",
        Footer: "userId",
        accessor: "userId",
      },
      {
        Header: "Name",
        Footer: "name",
        accessor: "name",
      },
      // {
      //   Header: "created Date",
      //   Footer: "createdDate",
      //   accessor: "createdDate", // accessor is the "key" in the data
      // },
      // {
      //   Header: "Values",
      //   Footer: "Values",
      //   accessor: "values",
      // },

      {
        Header: "Status",
        Footer: "Status",
        accessor: "response",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {console.log("cell111", cell)}
              {cell.row.original.response == true ? (
                <>
                  <span class="badge bg-danger activated_1">Pending</span>
                </>
              ) : (
                <>
                  <span class="badge bg-success activated_1">success</span>
                </>
              )}

              {/* <DeleteIcon /> */}
            </button>
          </div>
        ),
      },
    ],
    []
  );
  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,

    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    prepareRow,
    state,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <ToastContainer />
        <div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3 mt-4">
                {/* <div className="col mt-auto text-end ">
                  <button
                    type="button"
                    className="btn bg-gradient-primary w_btn m-0 me-4  bgcolor "
                    onClick={() => {
                      toast.success("jello");
                    }}
                  >
                    Add
                  </button>
                </div> */}
                <ThemeProvider theme={theme}>
                  <div className="card-body">
                    <form
                      onSubmit={formik.handleSubmit}
                      role="form"
                      className="text-start"
                    >
                      <div className="card shadow-none border bg_blue mb-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                          ADD MEDIUM MASTER
                        </span>
                        <div className="row mt-4">
                          <div className="col-md-3">
                            <TextField
                              autoComplete="on"
                              className="ms-4 w-75"
                              type="text"
                              label="Name"
                              name="Name"
                              variant="outlined"
                              size="small"
                              required
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Name"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                              onChange={formik.handleChange}
                              value={formik.values.Name}
                              error={
                                formik.touched.ruleName &&
                                Boolean(formik.errors.Name)
                              }
                              helperText={
                                formik.touched.Name && formik.errors.Name
                              }
                            />
                          </div>
                          <div className="col-md-3">
                            <FormControl fullWidth size="small">
                              <InputLabel id="demo-simple-select-autowidth-label">
                                Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={response}
                                onChange={handleChange11}
                                // autowidth
                                label="Status"
                              >
                                <MenuItem value="true">Active</MenuItem>
                                <MenuItem value="false">No-Active</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>

                        <div className="card-body text-lg-start text-center">
                          {/* </div> */}
                          <div className="mt-4 text-sm text-end">
                            <button
                              type="submit"
                              // onClick={CreateMedium}
                              className="btn bg-gradient-primary mt-4 me-4 w_btn"
                            >
                              Add
                              <i className="material-icons opacity-10">
                                {/* arrow_right_alt */}
                              </i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="p-4">
                        <div className="d-flex justify-content-between">
                          <table
                            {...getTableProps()}
                            id="example"
                            className="table table-striped table-bordered dataTable table-sm"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                  {headerGroup.headers.map((column) => (
                                    <th
                                      {...column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      )}
                                      className="text-center width_2"
                                    >
                                      {column.render("Header")}
                                      <span>
                                        {column.isSorted
                                          ? column.isSortedDesc
                                            ? "↑"
                                            : "↓"
                                          : ""}
                                      </span>

                                      {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                              {page.map((row) => {
                                prepareRow(row);
                                return (
                                  <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                      return (
                                        <td
                                          {...cell.getCellProps()}
                                          className="text-center"
                                        >
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </tbody>
                            {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                          </table>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <span>
                              Page:
                              <strong>
                                {pageIndex + 1} of {pageOptions.length}
                              </strong>
                            </span>

                            <span>
                              | Go to Page :{""}
                              <input
                                type="number"
                                defaultValue={pageIndex + 1}
                                onChange={(e) => {
                                  const pageNumber = e.target.value
                                    ? Number(e.target.value) - 1
                                    : 0;
                                  gotoPage(pageNumber);
                                }}
                                style={{ width: "50px" }}
                              />
                            </span>
                          </div>

                          <div>
                            {/* <button
                  onClick={() => {
                    gotoPage(0);
                  }}
                  disabled={!canPreviousPage}
                >
                  {"<<"}
                </button> */}

                            <div>
                              <button
                                style={{ background: "#0885ef" }}
                                className="btn btn_primary m-0"
                                type="button"
                                disabled={!canPreviousPage}
                                onClick={() => {
                                  previousPage();
                                }}
                              >
                                Prev
                              </button>

                              <button
                                style={{ background: "#0885ef" }}
                                className="btn btn_primary m-0 ms-2"
                                type="button"
                                disabled={!canNextPage}
                                onClick={() => {
                                  nextPage();
                                }}
                              >
                                Next
                              </button>
                            </div>

                            {/* <button
                  onClick={() => {
                    gotoPage(pageCount - 1);
                  }}
                  disabled={!canNextPage}
                >
                  {">>"}
                </button> */}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default withRouter(SpamRules);
